import React, { useState, useEffect, useRef, useCallback } from "react";
import { useKeyPress, useOnClickOutside } from "../../../utility/services/customHooks";



export default function InLineEdit(props) {
  const [isInputActive, setIsInputActive] = useState(false);
  const [inputValue, setInputValue] = useState(props.text);
  const [blankInput, setBlankInput] = useState(false);

  const wrapperRef = useRef(null);
  const textRef = useRef(null);
  const inputRef = useRef(null);

  const enter = useKeyPress("Enter");
  const esc = useKeyPress("Escape");

  const { onSetText } = props;

  // check to see if the user clicked outside of this component
  useOnClickOutside(wrapperRef, () => {
    if (isInputActive && inputValue) {
      onSetText(inputValue);
      setIsInputActive(false);
      setBlankInput(false)
    }
    if (isInputActive && !inputValue) {
      onSetText('Please Enter a value');
      setBlankInput(true)
    }
  });

  const onEnter = useCallback(() => {
    if (enter) {
      if (!inputValue) {
        onSetText('Please Enter a value');
        setBlankInput(true);
      }
      else {
        setIsInputActive(false);
        onSetText(inputValue);
        setBlankInput(false);
      }
    }
  }, [enter, inputValue, onSetText]);

  const onEsc = useCallback(() => {
    if (esc) {
      setInputValue(props.text);
      setIsInputActive(false);
    }
  }, [esc, props.text]);

  // focus the cursor in the input field on edit start
  useEffect(() => {
    if (isInputActive) {
      inputRef.current.focus();
    }
  }, [isInputActive]);

  useEffect(() => {
    if (isInputActive) {
      // if Enter is pressed, save the text and close the editor
      onEnter();
      // if Escape is pressed, revert the text and close the editor
      onEsc();
    }
  }, [onEnter, onEsc, isInputActive]); // watch the Enter and Escape key presses

  const handleInputChange = useCallback(
    event => {
      // sanitize the input a little
      setInputValue(event.target.value);
    },
    [setInputValue]
  );

  const handleSpanClick = useCallback(() => setIsInputActive(true), [
    setIsInputActive
  ]);

  return (
    <span id="content_recommendation__span__in_line_edit_0" className="inline-text" ref={wrapperRef}>
      <span
        id="content_recommendation__span__in_line_edit_1"
        ref={textRef}
        onClick={handleSpanClick}
        className={`inline-text_copy inline-text_copy--${
          blankInput ? 'blank' : !isInputActive ? "active" : "hidden"
          }`}
      >
        {props.text}
      </span>
      <input
        id="content_recommendation__input__in_line_edit_2"
        ref={inputRef}
        // set the width to the input length multiplied by the x height
        // it's not quite right but gets it close
        style={{ minWidth: Math.ceil(inputValue.length) + "ch" }}
        maxLength={60}
        value={inputValue}
        onChange={handleInputChange}
        className={`inline-text_input inline-text_input--${
          blankInput ? 'blank' : isInputActive ? "active" : "hidden"
          }`}
      />
    </span>
  );
}


